var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoodBestPossible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_radial_40_49260)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18.5091,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 2.98182
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.8364 25.0871C14.8364 27.3053 13.0364 29.1235 10.8182 29.1235C8.60005 29.1235 6.80005 27.3235 6.80005 25.0871C6.80005 22.869 8.60005 21.0508 10.8182 21.0508C13.0364 21.0508 14.8364 22.8508 14.8364 25.0871Z",
    fill: "url(#paint1_radial_40_49260)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.3819 25.0871C33.3819 27.3053 31.5819 29.1235 29.3638 29.1235C27.1456 29.1235 25.3456 27.3235 25.3456 25.0871C25.3456 22.869 27.1456 21.0508 29.3638 21.0508C31.5819 21.0508 33.3819 22.8508 33.3819 25.0871Z",
    fill: "url(#paint2_radial_40_49260)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8546 18.7092C22.8546 20.7274 24.491 22.3638 26.5092 22.3638C28.5273 22.3638 30.1637 20.7274 30.1637 18.7092C30.1637 16.6911 28.5273 15.0547 26.5092 15.0547C24.491 15.0547 22.8546 16.6911 22.8546 18.7092Z",
    fill: "#F757B0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1273 18.2895C22.1273 20.3076 23.7637 21.944 25.7819 21.944C27.8 21.944 29.4364 20.3076 29.4364 18.2895C29.4364 16.2713 27.8 14.6349 25.7819 14.6349C23.7637 14.6167 22.1273 16.2531 22.1273 18.2895Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1091 18.2899C24.1091 19.2172 24.8546 19.9626 25.7637 19.9626C26.6728 19.9626 27.4182 19.2172 27.4182 18.2899C27.4182 17.3626 26.6728 16.6172 25.7637 16.6172C24.8546 16.6172 24.1091 17.3626 24.1091 18.2899Z",
    fill: "#14110E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4 17.5254C26.4 17.9435 26.7455 18.289 27.1637 18.289C27.5818 18.289 27.9273 17.9435 27.9273 17.5254C27.9273 17.1072 27.5818 16.7617 27.1637 16.7617C26.7455 16.7617 26.4 17.1072 26.4 17.5254Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2729 11.6189C27.1457 12.1644 28.0548 12.6735 28.8911 13.2916C29.2184 13.528 28.9093 14.0735 28.582 13.8371C27.7457 13.2189 26.8548 12.7098 25.9638 12.1644C25.6002 11.9462 25.9275 11.4007 26.2729 11.6189Z",
    fill: "#F757B0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2729 11.1463C27.1457 11.6917 28.0548 12.2008 28.8911 12.819C29.2184 13.0553 28.9093 13.6008 28.582 13.3644C27.7457 12.7463 26.8548 12.2372 25.9638 11.6917C25.6002 11.4735 25.9275 10.9281 26.2729 11.1463Z",
    fill: "#14110E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 11.6189C12.3273 12.1644 11.4182 12.6735 10.5818 13.2916C10.2545 13.528 10.5636 14.0735 10.8909 13.8371C11.7273 13.2189 12.6182 12.7098 13.5091 12.1644C13.8545 11.9462 13.5454 11.4007 13.2 11.6189Z",
    fill: "#F757B0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 11.1463C12.3273 11.6917 11.4182 12.2008 10.5818 12.819C10.2545 13.0553 10.5636 13.6008 10.8909 13.3644C11.7273 12.7463 12.6182 12.2372 13.5091 11.6917C13.8545 11.4735 13.5454 10.9281 13.2 11.1463Z",
    fill: "#14110E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.509 19.4371C16.909 16.528 12.9636 15.9825 10.6545 16.9644C10.3272 17.1098 10.6181 17.5825 10.9272 17.4371C12.3999 16.8007 14.6727 16.8916 15.9999 17.9644C14.0727 16.8916 11.3272 17.5462 10.1999 19.6371C10.0363 19.9462 10.509 20.2371 10.6727 19.9098C11.9272 17.6007 15.5454 17.2734 16.9272 19.6371C16.9818 19.7462 17.0909 19.7825 17.1818 19.7644C17.3454 19.8007 17.5454 19.6553 17.509 19.4371Z",
    fill: "#14110E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4545 25.0723C26.4545 25.0723 20.6182 25.5086 14.0727 25.0723C14.0727 25.0723 12.9272 31.3995 20.0181 31.3995C27.2727 31.3995 26.4545 25.0723 26.4545 25.0723Z",
    fill: "#14110E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9091 25.1094C25.8545 25.7276 25.7818 26.3457 25.6909 26.9639C23.7273 27.2185 19.9091 27.5276 15.2364 26.9821C15.1273 26.3639 15.0364 25.7457 14.9636 25.1276C19.9636 25.4003 24.3818 25.2003 25.9091 25.1094Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9091 29.2373C20.8727 27.4919 23.8182 29.1646 24.7636 29.8919C23.8 30.7646 22.3091 31.401 20.0181 31.401C17.2363 31.401 15.7272 30.4191 14.9091 29.2373Z",
    fill: "#FC2727"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4182 31.3817C19.2545 31.3817 19.1091 31.3636 18.9454 31.3454C19.1454 30.3817 19.4363 29.4181 19.7454 28.4727C19.9091 28.4727 20.0727 28.4727 20.2363 28.4908C19.9272 29.4363 19.6182 30.3999 19.4182 31.3817Z",
    fill: "#D82525"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_40_49260",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 20) rotate(90) scale(20)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.487641,
    stopColor: "#F78BC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D60A7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_40_49260",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8214 25.0786) scale(4.0178 4.03226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE278D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#DE278D",
    stopOpacity: 0.8196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#DE278D",
    stopOpacity: 0.579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    stopColor: "#DE278D",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#DE278D",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9914,
    stopColor: "#972464",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_40_49260",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.3669 25.0786) scale(4.0178 4.03226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE278D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#DE278D",
    stopOpacity: 0.8196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#DE278D",
    stopOpacity: 0.579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    stopColor: "#DE278D",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#DE278D",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9914,
    stopColor: "#972464",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodBestPossible);
export default __webpack_public_path__ + "static/media/mood-best-possible.c3677e6648b177eee583d5e51842e74c.svg";
export { ForwardRef as ReactComponent };